import React, { Fragment, useCallback, useContext } from "react";
import Axios from "axios";
import { AuthContext, Row, AccountNav, useAPI, Grid } from "components/lib";
import "survey-core/defaultV2.min.css";
import { applyStackgoTheme } from "components/survey/stackgo-theme";
import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";

StylesManager.applyTheme("defaultV2");

const json = {
  completedHtml: "<h3>Your changes have been saved.</h3>",
  navigateToUrl: "/account",
  pages: [
    {
      name: "Enable Custom Notification Settings",
      elements: [
        {
          type: "boolean",
          name: "enableCustomNotifications",
          title: "Enable Custom Notification Settings",
          isRequired: true,
        },
      ],
    },
    {
      name: "info",
      elements: [
        {
          type: "text",
          inputType: "email",
          name: "notificationEmail",
          title: "Notification Email",
          description:
            "Email address to send notifications for each IdentityCheck Verification",
          isRequired: true,
          enableIf: "{enableCustomNotifications} = true",
        },
        {
          type: "text",
          inputType: "text",
          name: "redirectUrl",
          title: "Redirect URL",
          prefix: "https://",
          description: "URL to redirect to after verification is complete",
          placeholder: "example.com/path",
          isRequired: false,
          enableIf: "{enableCustomNotifications} = true",
          validators: [
            {
              type: "regex",
              text: "Please enter a valid domain name (e.g. example.com/path)",
              regex: "^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+(\\/.*)?$",
            },
          ],
        },
      ],
    },
  ],
  showQuestionNumbers: "off",
};

export function NotificationSettingsView(props) {
  const accountInfo = useAPI("/api/account");
  const survey = new Model(json);
  applyStackgoTheme(survey);

  async function saveSurveyResults(url, json) {
    console.log("saveSurveyResults", url, json);
    const response = await Axios.post(url, json);
    console.log("saveSurveyResults response", response);
  }

  function setExistingNotificationSettings() {
    if (!accountInfo?.loading && accountInfo?.data) {
      survey.setValue(
        "enableCustomNotifications",
        accountInfo?.data.notification_enabled
      );
      survey.setValue(
        "notificationEmail",
        accountInfo?.data.notification_settings?.notificationEmail
      );
      const savedUrl = accountInfo?.data.notification_settings?.redirectUrl;
      survey.setValue(
        "redirectUrl",
        savedUrl ? savedUrl.replace(/^https:\/\//, "") : ""
      );
    }
  }

  const customNotificationConfigComplete = useCallback((sender) => {
    const data = { ...sender.data };
    if (data.redirectUrl) {
      data.redirectUrl = "https://" + data.redirectUrl.replace(/^https:\/\//, "");
    }
    saveSurveyResults("/api/account/notifications", data);
    window.location = "/account";
  });

  useContext(AuthContext);

  setExistingNotificationSettings();
  survey.onComplete.add(customNotificationConfigComplete);

  return (
    <Fragment>
      <AccountNav />
      <Grid>
        <Row>
          <h1>Manage Notifications</h1>
          {!accountInfo?.loading && <Survey model={survey} />}
        </Row>
      </Grid>
    </Fragment>
  );
}
